import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';

// import { BranchCategoryGridPostParams } from 'common/models/page-models/branch-category-model';
import { environment } from 'src/environments/environment';
import { EmailTemplateModel } from 'common/models/page-models/Email-Template/email-template-data-model';
import { EmailTemplateGridParams, EmailTemplateListingModel } from 'common/models/page-models/Email-Template/email-template-grid-model';
import { GridDataService } from '../../base-data-services/grid-data.service';



@Injectable({
    providedIn: 'root'
})
export class EmailTemplateGridDataService extends GridDataService<EmailTemplateListingModel, EmailTemplateModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getTemplateList, http, ss);

    }

    createInstance(): EmailTemplateListingModel {
        return new EmailTemplateListingModel();
    }


    getDeleteUrl() {
        return environment.apiUrl + API_URL.deleteEmailTemplate;
    }

    getViewUrl(): string {

        return API_URL.templateEmail;
    }

    override getGridParams(): GridPostParams {
        return new EmailTemplateGridParams();
    }

}
